import {
  AllocateActionRequestModel,
  AllocationByRuleActionRequestModel,
  AllocationDetailsModel,
  AllocationManualActionRequestModel,
  AllocationViewSelectedEntityModel,
  AllocationViewTimeslotRequestModel,
} from '../../models';

export class AllocationViewAllocateActionLoadAllocationDetails {
  public static readonly type = '[AllocationViewAllocateAction] Load Allocation Details';

  constructor(public payload: AllocationViewSelectedEntityModel) {}
}

export class AllocationViewAllocateActionUpdateAllocationDetails {
  public static readonly type = '[AllocationViewAllocateAction] Update Allocation Details';

  constructor(public payload: AllocationDetailsModel) {}
}

export class AllocationViewAllocateActionLoadCompartments {
  public static readonly type = '[AllocationViewAllocateAction] Load Compartments';

  constructor(public payload: number) {}
}

export class AllocationViewAllocateActionLoadDocks {
  public static readonly type = '[AllocationViewAllocateAction] Load Docks';

  constructor(public payload: AllocateActionRequestModel) {}
}

export class AllocationViewAllocateActionLoadRules {
  public static readonly type = '[AllocationViewAllocateAction] Load Rules';

  constructor(public payload: AllocateActionRequestModel) {}
}

export class AllocationViewAllocateActionLoadRuleSlots {
  public static readonly type = '[AllocationViewAllocateAction] Load Rule Slots';

  constructor(public payload: { details: AllocationDetailsModel; ruleId: number }) {}
}

export class AllocationViewAllocateActionLoadRuleSlotsWithoutDetails {
  public static readonly type = '[AllocationViewAllocateAction] Load Rule Slots Without Details';

  constructor(public payload: { ruleId: number; hubId: number }) {}
}

export class AllocationViewAllocateActionLoadProposedTimeslot {
  public static readonly type = '[AllocationViewAllocateAction] Load Proposed Timeslot';

  constructor(public payload: AllocationViewTimeslotRequestModel) {}
}

export class AllocationViewAllocateActionManualAllocateUli {
  public static readonly type = '[AllocationViewAllocateAction] Manual Allocate ULI';

  constructor(public payload: AllocationManualActionRequestModel) {}
}

export class AllocationViewAllocateActionAutoAllocateUli {
  public static readonly type = '[AllocationViewAllocateAction] Auto Allocate ULI';

  constructor(public payload: AllocateActionRequestModel) {}
}

export class AllocationViewAllocateActionAllocateByRuleUli {
  public static readonly type = '[AllocationViewAllocateAction] Allocate By Rule ULI';

  constructor(public payload: AllocationByRuleActionRequestModel) {}
}

export class AllocationViewAllocateActionResetProposedTimeslot {
  public static readonly type = '[AllocationViewAllocateAction] Reset Proposed Timeslot';
}

export class AllocationViewAllocateActionSetCloseAfterCompleteState {
  public static readonly type = '[AllocationViewAllocateAction] Set Close After Complete State';

  constructor(public payload: boolean) {}
}

export class AllocationViewAllocateActionSetInitialState {
  public static readonly type = '[AllocationViewAllocateAction] Set Initial State';
}
